"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
var CircularProgress_1 = require("../CircularProgress");
var styles_1 = require("../styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) { return ({
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}); });
var LoadingButton = function (_a) {
    var loading = _a.loading, children = _a.children, buttonProps = __rest(_a, ["loading", "children"]);
    var classes = useStyles();
    return (react_1.default.createElement(Button_1.Button, __assign({}, buttonProps),
        children,
        ' ',
        loading && (react_1.default.createElement(CircularProgress_1.CircularProgress, { size: 24, className: classes.buttonProgress }))));
};
exports.default = LoadingButton;
//# sourceMappingURL=LoadingButton.js.map